import React from "react";

import AndroidLogo from "./img/android.png";
import VScodeLogo from "./img/vscode.png";
import MSSqlLogo from "./img/mssql.png";
import GithubLogo from "./img/github.png";
import FirebaseLogo from "./img/firebase.png";
import HerokuLogo from "./img/heroku.png";
import AdobeXDLogo from "./img/xd.png";
import AzureLogo from "./img/azure.png";

export default function ToolsComponent() {
  return (
    <div
      class="education group"
      data-aos="fade-up"
      data-aos-delay="300"
      data-aos-duration="400"
    >
      <h2 class="text-center">Tools and Technologies</h2>
      <center>
        <div className="row">
          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={AndroidLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Android
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={VScodeLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Visual Studio Code
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={MSSqlLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Microsoft SQL Server
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={GithubLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              GitHub
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={FirebaseLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Firebase
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={HerokuLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Heroku
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={AdobeXDLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Adobe XD
            </p>
          </div>

          <div
            className="col-md-3"
            data-aos="zoom-in"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <img src={AzureLogo} className="TechLogo" />
            <p class="text-muted text-center" style={{ fontWeight: "bold" }}>
              Azure
            </p>
          </div>
        </div>
      </center>
    </div>
  );
}
